import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsModule } from './shared/core/modules/icons.module';
import { StoreModule } from '@ngrx/store';
import {
    routerReducer,
    StoreRouterConnectingModule,
    RouterState
} from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { LayoutModule } from './layout/layout.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { appFeature } from './shared/state/reducers';
import { AppEffects } from './shared/state/effects';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { NgxGoogleAnalyticsModule, provideGoogleAnalytics, provideGoogleAnalyticsRouter } from '@hakimio/ngx-google-analytics';

import { AuthGuardService } from '@app/core/services/auth/auth-guard.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpTokenInterceptor } from '@app/core/interceptors/token.interceptor';
import { ProfileResolver } from '@app/core/resolvers/profile.resolver';

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        IconsModule,
        LayoutModule,
        StoreModule.forRoot({
            router: routerReducer,
            app: appFeature.reducer
        }, { runtimeChecks: { strictActionImmutability: true } }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true
        }),
        EffectsModule.forRoot([
            AppEffects
        ]),
        StoreRouterConnectingModule.forRoot({ routerState: RouterState.Minimal }),
        ToastrModule.forRoot(),
        RecaptchaV3Module,
        NgxGoogleAnalyticsModule
    ],
    providers: [
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideGoogleAnalytics(environment.google_analytics.measurement_id),
        provideGoogleAnalyticsRouter(),
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptcha.siteKey,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpTokenInterceptor,
            multi: true
        },
        AuthGuardService,
        ProfileResolver
    ]
})
export class AppModule { }
